const SPECIAL_INVENTORY_ITEMS = [
  {
    title: 'Large safe',
    subtext: 'Over 36” x 36”',
    key: 'large-safe',
  },
  {
    title: 'Dish washer',
    subtext: 'Must be disconnected',
    key: 'dishwasher',
  },
  {
    title: 'Washer/Dryer',
    subtext: 'Must be disconnected',
    key: 'washer-dryer',
  },
  {
    title: 'Large freezer',
    subtext: 'Over 48” x 48”',
    key: 'large-freezer',
  },
  {
    title: 'Refrigerator',
    subtext: 'Must be disconnected',
    key: 'refrigerator',
  },
  {
    title: 'Upright piano',
    subtext: 'Special movers recommended for grand/baby grand pianos',
    key: 'piano',
    tooltip: 'For grand or baby grand pianos we recommend hiring a specialty piano mover.',
  },
  {
    title: 'Oven/Stove',
    subtext: 'Must be disconnected',
    key: 'oven-stove',
  },
  {
    title: 'Large armoire',
    subtext: 'Over 68” tall',
    key: 'large-armoire',
  },
  {
    title: 'Riding lawn mower',
    subtext: 'May require additional truck',
    key: 'riding-lawn-mower',
  },
];

export const INITIAL_SPECIAL_INVENTORY_ITEMS = SPECIAL_INVENTORY_ITEMS.reduce(
  (prev, item) => ({ ...prev, [item.key]: 0 }),
  {},
);

export default SPECIAL_INVENTORY_ITEMS;
